<template>
    <Dialog
        :value="true"
        :header-text="title"
        :width="528"
        persistent
        fixed
        @close_modal="$emit('close')"
    >
        <div class="pb-5">
            <div
                v-for="(attachment) in attachments"
                :key="attachment.id"
            >
                <checkbox
                    class="mt-1"
                    :value="selectedAttachmentIds.includes(attachment.id || attachment.temp_name)"
                    @change="onSelectedAttachmentChange($event, attachment)"
                >
                    <AttachmentChip :file="attachment" />
                </checkbox>
            </div>
        </div>
        <template slot="footer">
            <v-spacer />
            <primary-button
                :disabled="selectedAttachmentIds.length === 0"
                @click="onSend"
            >
                {{ $t('Send') }}
            </primary-button>
        </template>
    </Dialog>
</template>

<script>
import { $t } from "@/i18n";
import {computed, ref} from "@vue/composition-api";
import Dialog from "@/components/Dialog";
import ApiDigitization from '@/api/client/digitization';
import AttachmentChip from "@/components/AttachmentChip.vue";
import FeedbackNotificationModule from "@/store/modules/feedback_notification";
import errorDialog from "@/views/ErrorDialog/errorDialog";
import { capitalize } from "@/plugins/formatting";

export default {
    name: "EditTemplateIndex",
    components: {
        Dialog,
        AttachmentChip
    },
    props: {
        attachments: {
            type: Array,
            required: true
        },
        digitizationEmail: {
            type: String,
            required: true
        },
        clientId: {
            type: Number,
            required: true
        }
    },
    setup(props, ctx) {
        const { showFeedbackNotification } = FeedbackNotificationModule();

        const selectedAttachmentIds = ref(props.attachments.map(x => x.id ? x.id : x.temp_name))

        const digitizationEmailDomain = computed(() => {
            const domain = props.digitizationEmail.split('@')[1]
            if (!domain) {
                return null
            }

            const domainWithoutExtensions = domain.split('.')[0]
            const finalDomain = domainWithoutExtensions ? domainWithoutExtensions : domain

            return capitalize(finalDomain)
        })

        const title = computed(() => {
            return $t('Digitise') + ' -> ' + digitizationEmailDomain.value
        })

        const onSend = async () => {
            try {
                await ApiDigitization.postDigitize(
                    props.clientId,
                    selectedAttachmentIds.value.filter(x => !isNaN(x)),
                    selectedAttachmentIds.value.filter(x => isNaN(x))
                )
                showFeedbackNotification($t('Documents sent to digitisation'))
                ctx.emit('close')
            } catch (e) {
                errorDialog.showError(e)
            }
        }

        const onSelectedAttachmentChange = (isSelected, attachment) => {
            const attachmentId = attachment.id ? attachment.id : attachment.temp_name

            if (isSelected) {
                selectedAttachmentIds.value.push(attachmentId)
            } else {
                selectedAttachmentIds.value = selectedAttachmentIds.value.filter(x => x !== attachmentId)
            }
        }

        return {
            title,
            selectedAttachmentIds,
            onSend,
            onSelectedAttachmentChange
        }
    }
}
</script>

<style scoped>

</style>